import React from 'react';
import PropTypes from 'prop-types';
import ArticleCard from '../../../Lander/ArticleCard';
import { isValid, decodeSpecialCharacters } from '../../../../utils';
import '../../../Lander/lander-pw.scss';

const ArticlePicker = ({ header, blurb=null, data, isMobile, isContentHub }) => {
  if (!isValid(data)) { return null; }
  const {
    id = null,
    cateogory = null,
    authorName = null,
    sponsored = null,
    url = null,
    headline = null,
  } = data;

  const {
    categoryImage: {
      imageId,
      topcard,
      topcardMobile,
      mobileHeight,
      mobileWidth,
      imageCredit,
      imageAlt,
      universalCredit,
      bigcard,
      smallcard,
      card,
      featurecard, 
      featurecardMobile,
    } = {},
  } = data;
  const decodedBlurb = decodeSpecialCharacters(blurb);
  const renderedArticleCards = isValid(data) ? data.map((article, i) => {
    article.cardClass = 'big-card';
    return (
        <ArticleCard key={i} data={article} isMobile={isMobile} shouldDisplaySponsored={true} showCategory={false} isContentHub={isContentHub}/>
    );
  }) : null;

  return (
    <>
      <div className='vertical-section-wrapper'>
      <div className="vertical-section grid-container">
          <h2 className='section-hed' dangerouslySetInnerHTML={{ __html: header }}></h2>
          {isValid(blurb) && <div className='section-blurb' dangerouslySetInnerHTML={{ __html: decodedBlurb }}/> }
          <div className='category-hr'/>
          <div className='article-cards'>
            {renderedArticleCards}
          </div>
      </div>
      </div>
    </>
  );
};

ArticlePicker.propTypes = {
  data: PropTypes.array,
};

export default ArticlePicker;
